var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { pointAtOrigin } from "./point-at-origin";
export var cPointAtOrigin = function (originX, originY) {
  return function (radius, angleInDegrees) {
    var _a = __read(pointAtOrigin(originX, originY)(radius, angleInDegrees), 2),
      x = _a[0],
      y = _a[1];
    return {
      cx: x,
      cy: y
    };
  };
};